import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  learnerVersionsRequest,
  learnerVersionsSuccess,
  learnerVersionsFailure,
} from '../reducers/savedVersions';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/user/`;

function* savedVersionsAxios() {
  const state = yield select(fullState => fullState);
  const {
    user: { userId },
    token,
  } = state.loginReducer;
  const contentId = state.userProgramsFullReducer.selectedContentId;
  const { pathToSaveVersion: pathToVersion } = state.savedVersionsReducer;

  const response = yield call(() =>
    axios({
      method: 'get',
      url: `${API}${userId}/content/${contentId}/versions`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
      data: {
        pathToVersion,
      },
    }),
  );

  return response;
}

function* workerSavedVersionsSaga() {
  try {
    const response = yield call(savedVersionsAxios);
    if (response.status === 200) {
      
      yield put(learnerVersionsSuccess(response.data.data));
    }
    if (response.status === 205) {
      yield put(learnerVersionsFailure('No versions for this contentId'));
    }
    if (response.status === 207) {
      yield put(learnerVersionsFailure('No versions for this contentId'));
    }
    if (response.status === 206) {
      yield put(learnerVersionsFailure('Content does not exist'));
    }
  } catch (error) {
    yield put(learnerVersionsFailure(error));
  }
}

export function* watcherSavedVersionsSaga() {
  yield takeLatest(learnerVersionsRequest().type, workerSavedVersionsSaga);
}
